import { useEffect, useState } from "react";
import CompanyView from "./CompanyView";
import AgentsView from "./AgentsView";
import OperationsView from "./OperationsView";
import RetailerUsersView from "./RetailerUsersView";
import CustomerList from "../Retailer/CustomerList";
import { useLocation } from "react-router-dom";

export default function PartnersTabs() {
  const [activeTab, setActiveTab] = useState("mcp");

  const tabs = [
    { key: "mcp", label: "Master Channel Partner" },
    { key: "cp", label: "Channel Partner" },
    { key: "arp", label: "Authorized Retail Partner" },
    { key: "arp_user", label: "ARP User" },
    { key: "customer", label: "Customers" },
  ];

  const location = useLocation();

useEffect(() => {
  if (location.state?.activeTab) {
    setActiveTab(location.state.activeTab);
  }
}, [location.state]);

  return (
    <div className="space-y-4">

      {/* 🔹 Tabs Header */}
      <div className="flex gap-2 flex-wrap">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 rounded-xl text-sm font-semibold transition-all
              ${
                activeTab === tab.key
                  ? "bg-blue-600 text-white shadow"
                  : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* 🔹 Tab Content */}
      <div>
        {activeTab === "mcp" && <CompanyView />}

        {activeTab === "cp" && (
          <AgentsView />
        )}

        {activeTab === "arp" && (
          <OperationsView />
        )}

        {activeTab === "arp_user" && (
          <RetailerUsersView />
        )}

        {activeTab === "customer" && (
          <CustomerList />
        )}
      </div>

    </div>
  );
}